


















































import Vue from "vue";
import iwInputRadioGroup from "@/encoding/components/buildingBlocks/InputRadioGroup.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputRadioGroup: iwInputRadioGroup
    },

    props: {
        paymentDeclined: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: function() {
        return {
            pathInStore: "transaction.paymentMethod", // TODO: Refactor with correct value
            specificIdOnlineBanking: uuidv4() as string,
            specificIdCreditCard: uuidv4() as string,
            radiosOnlineBanking: [
                {"value": "BCMC", "label": "bancontact"},
            ],
            radiosCreditCard: [
                {"value": "VISA", "label": "visa"},
                {"value": "MASTERCARD", "label": "mastercard"}
            ]
        };
    },

    computed: {
        paymentMethod: function(): string {
            const value = this.$store.getters["FormModule/getValueTransaction"](this.pathInStore);
            if(value !== "") {
                return value;
            } else {
                return "";
            }
        },
    },

    methods: {
        updateValue: function(selectedValue: string): void {
            if (selectedValue.length) {
                this.$store.commit("OrdersModule/transactions/paymentMethod", selectedValue);
            }
        },
        urlOgone: function(): string|undefined {
            return process.env.VUE_APP_OGONE_ENDPOINT;
        }
    }
});
